import React, { Component } from "react";
import axios from "../../axios";
import Alert from "react-s-alert";
import qs from 'qs';
import moment from "moment";
import Paging from "../../components/Paging";
import FormDropdown from '../../components/FormDropdown';

const NewDate    = moment().format('YYYY-MM-DD')

class Penetapan extends Component {
	constructor(props) {
		super(props);

		this.state = {
            dataReport: [],
            dataKelas: [],
            kelas_id:"",
			master_id:"",
			user_id: "",
            pageCount    : 0,
            currentPage  : 0,
			date: "",
			created_by:"",
			isButtonLoading: false,
			isLoading   : false,
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this)
    	this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
	}

	handleChange(event) {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
    }
    
    handleChangeDatepicker(date, target) {
		date = moment(date, "x").format("YYYY-MM-DD");

		if (target === "mulai") {
			this.setState({
				master_tgl_jatuh_tempo: date
			});
		} else {
			this.setState({
				master_tgl_jatuh_tempo: date
			});
		}
    }
    
    handleCheckboxChange(siswa_id, finance) {

        // const target = event.target;
		// const value = target.type === "checkbox" ? target.checked : target.value;
        // alert(siswa_id);
		// newState[index].score = value;
        // this.setState({ checked: value })

        const params = qs.stringify({
            finance_id: this.props.match.params.forward_id,
            siswa_id:siswa_id,
            finance_tipe:'Forward',
            created_by:localStorage.SISMART_USER_ID

        })

        const url = finance == null ? '/siswa/finance/add' : '/siswa/finance/delete';
		// const url ='/siswa/finance/add';
		
		axios
			.post(url, params)
			.then(response => {
				const result = response.data;

				if (result.success) {
                    Alert.success(result.message);
                    // var diskon_nama = atob(this.props.match.params.diskon_nama);
                    this.props.history.replace('/forwardiuran/penetapan/'+this.props.match.params.forward_id+'/'+this.props.match.params.forward_nama);
					
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
							Alert.error(item);

							return true;
						});
					} else {
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log("ERROR", error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isButtonLoading: false });
			});
			this.setState({ showformAdd: false });
			window.location.reload()
	}

    handleSubmit() {
        let formData = new FormData();
        const config = {
			headers: { "content-type": "multipart/form-data" }
		};

		formData.append("created_by", localStorage.SISMART_USER_ID);
		formData.append("master_id", this.state.master_id);
		formData.append("group_id", this.state.group_id);
		formData.append("master_tgl_jatuh_tempo", this.state.master_tgl_jatuh_tempo);
		formData.append("tipe_id", this.state.tipe_id);
		formData.append("master_nominal", this.state.master_nominal);

		const url = this.props.mode === "Tambah" ? "/iuran/master/add" : "/iuran/master/update";

		this.setState({ isButtonLoading: true });

		axios.post(url, formData, config)
			.then(response => {
                
				const result = response.data;

				if (result.success) {
					Alert.success(result.message);
					this.props.history.replace("/diskoniuran");
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
							Alert.error(item);

							return true;
						});
					} else {
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log("ERROR", error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isButtonLoading: false });
			}); 
	}

    handlePageClick(data) {

        let selected = data.selected; // zero based index

        this.setState({currentPage: selected}, () => {
            this.loadData();
        });
    };

	loadData() {
		this.setState({isLoading: true, isButtonLoading: true})

        const params = qs.stringify({
            page: this.state.currentPage + 1,
            kelas_id: this.state.kelas_id,
            finance_id: this.props.match.params.forward_id

        })

        axios.get("/iuran/penetapan_forward?" + params)

            .then(response => {
                const result = response.data

                if (result.success === true) {
                    this.setState({
                        dataReport: Object.values(result.data.data),
                        pageCount: result.data.last_page,
                        isLoading: false,
                        isButtonLoading: false
                    });
                } else {
                    Alert.error(result.message);
                    this.setState({isLoading: false});
                }

            })

            .catch(error => {
                this.setState({isLoading: false});
                Alert.error("Gagal terhubung ke server!");
            });
	}

    loadDataKelas() {
        this.setState({ isButtonLoading: true });
        axios.post("/kelas")
            .then(response => {
                return response.data.data.map(item => ({
                    key: item.kelas_id,
                    value: item.kelas_nama
                }))
            })
            .then(result => {
                this.setState({
                    dataKelas: result,
                })
            })
            .catch(error => {
                console.log(error)
            })
    }
	
	
	componentDidMount() {
		this.loadData();
        this.loadDataKelas();
	}

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.location.search !== this.props.location.search || 
            prevState.kelas_id !== this.state.kelas_id) {
            this.loadData()
        }
    }

	render() {
		return (
			<div className="col-sm-12">
				<div className="card">
                    <div className="card-header">
                        Forward Iuran
                    </div>
                    <div className="card-block">
                        <div className="form-group row">
                            <div className="col-md-8">
                                <label className="form-control-label">Forward Nama : </label> <label>{atob(this.props.match.params.forward_nama)}</label>
                            </div>
                        </div>
						<div className="form-group row">
							<label className="col-md-1 form-control-label"style={{marginTop:3}}>Kelas : </label>
                             <div className="col-md-3">
                                <FormDropdown
                                    items={this.state.dataKelas}
                                    onChange={this.handleChange}
                                    style={{borderRadius:3}}
                                    value={this.state.kelas_id.toString()}
                                    name="kelas_id"
                                />
                            </div>
						</div>
                        {
                            this.state.isLoading ? "Memuat Data..." : (
                                this.state.dataReport.length === 0 ? "Data tidak ditemukan..." : (
                                    <div>
                                        <table className="table table-striped table-bordered animated fadeIn">
                                            <thead>
                                            <tr>
                                                <th>Checklist/All</th>
                                                <th>Siswa</th>
                                                <th>Kelas</th>
                                                <th>NISN</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                this.state.dataReport.map((item, i) => {

                                                    return (
                                                        <tr key={item.siswa_id}>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    style={{
                                                                        padding: "3px 7px",
                                                                        border: "1px solid #ccc",
                                                                        width: "5%"
                                                                    }}
                                                                    checked={item.finance_id != null ? 'checked' : ''}
                                                                    onClick={() => {
                                                                        this.handleCheckboxChange(item.siswa_id, item.finance_id);
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>{item.user_nama}</td>
                                                            <td>{item.kelas_nama}</td>
                                                            <td>{item.siswa_nisn}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            </tbody>
                                        </table>
                                        <Paging
                                            handlePageClick={this.handlePageClick}
                                            pageCount={this.state.pageCount}
                                            currentPage={this.state.currentPage}
                                        />
                                    </div>
                                )
                            )
                        }

                    </div>
                </div>
			</div>
		);
	}
}

export default Penetapan;



// WEBPACK FOOTER //
// ./src/views/ForwardIuran/Penetapan.js